import React, { FunctionComponent } from 'react';

import { AutomationForm } from '@components/bulk_management/automation/form/AutomationForm';
import { EditOrCreate, Views } from '@components/bulk_management/automation/AutomationEnums';

import { FontIcons } from '@components/library/icon';
import { TextButton } from '@components/library/button';

interface CreateViewProps {
  setView: SetStateDispatch<Views>;
}

export const CreateView: FunctionComponent<CreateViewProps> = ({
  setView,
}) => (
  <div>
    <TextButton
      className="return-to-home-button"
      icon={FontIcons.ArrowLeft}
      onClick={(): void => setView(Views.Home)}
    >
      {bfTranslate('Back to Automation Home')}
    </TextButton>
    <h2>{bfTranslate('Create Automation')}</h2>
    <AutomationForm editOrCreate={EditOrCreate.Create} goHome={(): void => setView(Views.Home)} />
  </div>
);
